import fetch from 'isomorphic-unfetch';

import {ResponseError} from '~/src/utilities/types/error';

const request = (url, options) => {
    return fetch(url, options).then((response) => {
        if (!response.ok) {
            throw new ResponseError(response);
        }
        return response;
    });
};

const getRequest = (url, options) => request(url, options);

const postRequest = (url, options, payload) =>
    request(url, {
        ...options,
        method: 'POST',
        body: JSON.stringify(payload)
    });

const patchRequest = (url, options, payload) =>
    request(url, {
        ...options,
        method: 'PATCH',
        body: JSON.stringify(payload)
    });

const deleteRequest = (url, options, payload) =>
    request(url, {
        ...options,
        method: 'DELETE',
        body: JSON.stringify(payload)
    });

const getJsonRequest = (url, options) => getRequest(url, options).then((response) => (response.status !== 204 ? response.json() : null));

const postJsonRequest = (url, options, payload) => postRequest(url, options, payload).then((response) => (response.status !== 204 ? response.json() : null));

const patchJsonRequest = (url, options, payload) => patchRequest(url, options, payload).then((response) => (response.status !== 204 ? response.json() : null));

const deleteJsonRequest = (url, options, payload) =>
    deleteRequest(url, options, payload).then((response) => (response.status !== 204 ? response.json() : null));

export {getRequest, postRequest, patchRequest, deleteRequest, getJsonRequest, postJsonRequest, patchJsonRequest, deleteJsonRequest};
